import { Context } from '../sdk/types';
import {
  ResponseMessage,
  ErrorMessage,
  ErrorMessageValue,
  InternalAppAction,
  RequestMessage,
} from '../types/actions';
import {
  InpPerformanceReport,
  LcpPerformanceReport,
  LogType,
  NetworkPerformanceReport,
  PerformanceType,
  TtfbPerformanceReport,
} from './types';

class LogUncaughtErrorRequest extends RequestMessage {
  value: { type: LogType; error: string };

  constructor(error: string) {
    super(InternalAppAction.LOGGER_LOG, {
      type: LogType.UNCAUGHT_ERROR,
      error,
    });
  }
}

class LogUncaughtErrorResponse extends ResponseMessage {
  value: undefined;

  constructor(uuid: string) {
    super(InternalAppAction.LOGGER_LOG, uuid);
  }
}

class LogUncaughtErrorError extends ErrorMessage {
  constructor(uuid: string, value: ErrorMessageValue) {
    super(InternalAppAction.LOGGER_LOG, uuid, value);
  }
}

class LogUnhandledRejectionRequest extends RequestMessage {
  value: { type: LogType; rejection: string };

  constructor(rejection: string) {
    super(InternalAppAction.LOGGER_LOG, {
      type: LogType.UNHANDLED_REJECTION,
      rejection,
    });
  }
}

class LogUnhandledRejectionResponse extends ResponseMessage {
  value: undefined;

  constructor(uuid: string) {
    super(InternalAppAction.LOGGER_LOG, uuid);
  }
}

class LogUnhandledRejectionError extends ErrorMessage {
  constructor(uuid: string, value: ErrorMessageValue) {
    super(InternalAppAction.LOGGER_LOG, uuid, value);
  }
}

class LogLcpPerformanceRequest extends RequestMessage {
  value: {
    type: LogType;
    performanceType: PerformanceType;
    performanceReport: LcpPerformanceReport;
  };

  constructor(lcpPerformanceReport: LcpPerformanceReport) {
    super(InternalAppAction.LOGGER_LOG, {
      type: LogType.PERFORMANCE,
      performanceType: PerformanceType.LCP,
      performanceReport: lcpPerformanceReport,
    });
  }
}

class LogLcpPerformanceResponse extends ResponseMessage {
  value: undefined;

  constructor(uuid: string) {
    super(InternalAppAction.LOGGER_LOG, uuid);
  }
}

class LogLcpPerformanceError extends ErrorMessage {
  constructor(uuid: string, value: ErrorMessageValue) {
    super(InternalAppAction.LOGGER_LOG, uuid, value);
  }
}

class LogTtfbPerformanceRequest extends RequestMessage {
  value: {
    type: LogType;
    performanceType: PerformanceType;
    performanceReport: TtfbPerformanceReport;
  };

  constructor(ttfbPerformanceReport: TtfbPerformanceReport) {
    super(InternalAppAction.LOGGER_LOG, {
      type: LogType.PERFORMANCE,
      performanceType: PerformanceType.TTFB,
      performanceReport: ttfbPerformanceReport,
    });
  }
}

class LogTtfbPerformanceResponse extends ResponseMessage {
  value: undefined;

  constructor(uuid: string) {
    super(InternalAppAction.LOGGER_LOG, uuid);
  }
}

class LogTtfbPerformanceError extends ErrorMessage {
  constructor(uuid: string, value: ErrorMessageValue) {
    super(InternalAppAction.LOGGER_LOG, uuid, value);
  }
}

class LogInpPerformanceRequest extends RequestMessage {
  value: {
    type: LogType;
    performanceType: PerformanceType;
    performanceReport: InpPerformanceReport;
  };

  constructor(inpPerformanceReport: InpPerformanceReport) {
    super(InternalAppAction.LOGGER_LOG, {
      type: LogType.PERFORMANCE,
      performanceType: PerformanceType.INP,
      performanceReport: inpPerformanceReport,
    });
  }
}

class LogInpPerformanceResponse extends ResponseMessage {
  value: undefined;

  constructor(uuid: string) {
    super(InternalAppAction.LOGGER_LOG, uuid);
  }
}

class LogInpPerformanceError extends ErrorMessage {
  constructor(uuid: string, value: ErrorMessageValue) {
    super(InternalAppAction.LOGGER_LOG, uuid, value);
  }
}

class LogNetworkPerformanceRequest extends RequestMessage {
  value: {
    type: LogType;
    performanceType: PerformanceType;
    performanceReport: NetworkPerformanceReport;
  };

  constructor(networkPerformanceReport: NetworkPerformanceReport) {
    super(InternalAppAction.LOGGER_LOG, {
      type: LogType.PERFORMANCE,
      performanceType: PerformanceType.NETWORK,
      performanceReport: networkPerformanceReport,
    });
  }
}

class LogNetworkPerformanceResponse extends ResponseMessage {
  value: undefined;

  constructor(uuid: string) {
    super(InternalAppAction.LOGGER_LOG, uuid);
  }
}

class LogNetworkPerformanceError extends ErrorMessage {
  constructor(uuid: string, value: ErrorMessageValue) {
    super(InternalAppAction.LOGGER_LOG, uuid, value);
  }
}

class LogContextRequest extends RequestMessage {
  value: { type: LogType; context: Context };

  constructor(context: Context) {
    super(InternalAppAction.LOGGER_LOG, {
      type: LogType.CONTEXT,
      context,
    });
  }
}

class LogContextResponse extends ResponseMessage {
  value: undefined;

  constructor(uuid: string) {
    super(InternalAppAction.LOGGER_LOG, uuid);
  }
}

class LogContextError extends ErrorMessage {
  constructor(uuid: string, value: ErrorMessageValue) {
    super(InternalAppAction.LOGGER_LOG, uuid, value);
  }
}

export {
  LogUncaughtErrorRequest,
  LogUncaughtErrorResponse,
  LogUncaughtErrorError,
  LogUnhandledRejectionRequest,
  LogUnhandledRejectionResponse,
  LogUnhandledRejectionError,
  LogLcpPerformanceRequest,
  LogLcpPerformanceResponse,
  LogLcpPerformanceError,
  LogTtfbPerformanceRequest,
  LogTtfbPerformanceResponse,
  LogTtfbPerformanceError,
  LogInpPerformanceRequest,
  LogInpPerformanceResponse,
  LogInpPerformanceError,
  LogNetworkPerformanceRequest,
  LogNetworkPerformanceResponse,
  LogNetworkPerformanceError,
  LogContextRequest,
  LogContextResponse,
  LogContextError,
};
